import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class ExceptionService {

  OK = 200;
  CREATED = 201;
  DELETED = 204;
  BAD_REQUEST = 400;
  UNAUTHORIZED = 401;
  NOT_FOUND = 404;
  METHOD_NOT_ALLOWED = 405;
  PAYLOAD_ERROR = 406;
  INTERNAL_SERVER_ERROR= 500;
  SERVICE_UNAVAILABLE = 503;

  toastConfig = {
    closeButton: true,
  }

  constructor(private toastrService: ToastrService) { }

  /** Handling the API Response Using Status Code */
  toastMessage(httpResponse: any, message: any) {
    if (httpResponse != null) {
      
      if (httpResponse == this.OK) {
        this.toastrService.success(this.validateMessage(httpResponse, message), undefined,this.toastConfig );
      } else if (httpResponse == this.CREATED) {
        this.toastrService.success(this.validateMessage(httpResponse, message), undefined,this.toastConfig);
      } else if (httpResponse == this.DELETED) {
        this.toastrService.success(this.validateMessage(httpResponse, message), undefined,this.toastConfig);
      } else if (httpResponse == this.BAD_REQUEST) {
        this.toastrService.error(this.validateMessage(httpResponse, message), undefined,this.toastConfig);
      } else if (httpResponse == this.NOT_FOUND) {
        this.toastrService.warning(this.validateMessage(httpResponse, message), undefined,this.toastConfig);
      } else if (httpResponse == this.METHOD_NOT_ALLOWED) {
        this.toastrService.error(this.validateMessage(httpResponse, message), undefined,this.toastConfig);
      }else if (httpResponse == this.PAYLOAD_ERROR) {
        this.toastrService.error(this.validateMessage(httpResponse, message), undefined,this.toastConfig);
      } else if (httpResponse == this.INTERNAL_SERVER_ERROR) {
        this.toastrService.error(this.validateMessage(httpResponse, message), undefined,this.toastConfig);
      } else if (httpResponse == this.SERVICE_UNAVAILABLE) {
        this.toastrService.error(this.validateMessage(httpResponse, message), undefined,this.toastConfig);
      }
    }
  }

  /** Validating the HTTP Response */
  validateMessage(httpResponse: any, message: any): string {
    if (message != undefined && message != '' && message != null) {
      return message;
    }
    return message;
  }
}
